<template>
  <div class="more-away">
    <div class="ha-des">
      <p class="black">问：如何修改个人信息？</p>
      <p>答：如下图中在APP中进入【我的】页面，再点击头像，就可以进入个人信息页面修改个人信息。</p>
    </div>
    <div class="ha-img">
      <img src="./img/userinfo.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-away {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何修改个人信息？')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
